/**
 * 导购Agent - 场景回复（场景话术库）接口
 *
 * 对齐后端《导购机器人场景话术库 API》：
 * - 独立于线索场景（/lead/scenarios*），使用导购自己的 guide_scenario* 表
 * - 导购场景没有留资阶段（lead_stage）区分，统一一套配置；其余字段与线索场景一致
 * - 分类不分版本，线上 / 草稿共用；场景按 version_type 区分，0 = 线上（只读），1 = 草稿
 */
import { apiGet, apiPost, apiPut, apiRequest } from '@/utils/request';
import type { LeadPaginated, LeadScenarioCategory, LeadScenarioPayload } from '@/types/leadPrompt';
import type { GuideScenario } from '@/types/guideAgent';

const remove = (url: string) => apiRequest(url, { method: 'DELETE' });

export const guideScenarioApi = {
  categories: {
    list: (robotId: number) =>
      apiGet<{ list: LeadScenarioCategory[] }>('/guide/scenario-categories', {
        robot_id: robotId,
      }),
    create: (robotId: number, name: string) =>
      apiPost<LeadScenarioCategory>('/guide/scenario-categories', { robot_id: robotId, name }),
    update: (id: number, name: string) =>
      apiPut<LeadScenarioCategory>(`/guide/scenario-categories/${id}`, { name }),
    delete: (id: number) => remove(`/guide/scenario-categories/${id}`),
  },
  scenarios: {
    list: (params: Record<string, unknown>) =>
      apiGet<LeadPaginated<GuideScenario>>('/guide/scenarios', params),
    create: (data: LeadScenarioPayload & { robot_id: number; version_type: number }) =>
      apiPost<GuideScenario>('/guide/scenarios', data),
    update: (id: number, data: LeadScenarioPayload) =>
      apiPut<GuideScenario>(`/guide/scenarios/${id}`, data),
    delete: (id: number) => remove(`/guide/scenarios/${id}`),
    setEnabled: (id: number, enabled: number) =>
      apiPut<{ id: number; enabled: number }>(`/guide/scenarios/${id}/enabled`, { enabled }),
  },
};
